export const executeAndSetInterval = (action: () => Promise<void>, interval: number) => {
  let timeout: NodeJS.Timeout | number
  let canceled = false

  const execute = async () => {
    await action()

    if (!canceled) {
      timeout = setTimeout(execute, interval)
    }
  }

  execute()

  return () => {
    canceled = true
    clearTimeout(timeout)
  }
}
